import * as React from 'react';
import { YMInitializer } from 'react-yandex-metrika';
import { memo, useEffect, useState } from 'react';
import { DATA_LAYER_KEY } from '../../analytics';
import { getLocale } from '../../utils';
import { useConfig } from '../../context';
import SbesAds from './SbesAds';
var AnalyticsEnum;
(function (AnalyticsEnum) {
    AnalyticsEnum[AnalyticsEnum["Yandex"] = 0] = "Yandex";
    AnalyticsEnum[AnalyticsEnum["SbesAds"] = 1] = "SbesAds";
})(AnalyticsEnum || (AnalyticsEnum = {}));
const defaultAccountsToInitialize = {
    [AnalyticsEnum.Yandex]: [],
    [AnalyticsEnum.SbesAds]: undefined
};
const isProd = process.env.NODE_ENV === 'production';
const AnalyticsComponent = memo(() => {
    const { global: { useYandexMetrika, useSberAds, yandexMetrikaId, sberAdsId } } = useConfig();
    // default websky metrika account
    const metrikaAccounts = [94079362];
    if (yandexMetrikaId) {
        if (Array.isArray(yandexMetrikaId)) {
            metrikaAccounts.push(...yandexMetrikaId.map(it => parseInt(it, 10)));
        }
        else {
            metrikaAccounts.push(parseInt(yandexMetrikaId, 10));
        }
    }
    const [accountsToInitialize, setAccountsToInitialize] = useState(defaultAccountsToInitialize);
    useEffect(() => {
        setTimeout(() => {
            var _a, _b;
            // setTimout because when this component uses in multiple places we need time gap between yandex metrica initializations
            const alreadyInitializedAccounts = window.yandex_metrika_accounts || [];
            setAccountsToInitialize({
                [AnalyticsEnum.Yandex]: metrikaAccounts.filter(account => !alreadyInitializedAccounts.includes(account)),
                [AnalyticsEnum.SbesAds]: !((_b = (_a = window.top100) === null || _a === void 0 ? void 0 : _a.Ch) === null || _b === void 0 ? void 0 : _b[sberAdsId]) ? +sberAdsId : undefined
            });
        }, 0);
    }, []);
    const yandexMetricsIds = accountsToInitialize[AnalyticsEnum.Yandex];
    const sberMetricsId = accountsToInitialize[AnalyticsEnum.SbesAds];
    const showYandexMetrics = useYandexMetrika && yandexMetricsIds.length > 0;
    const showSberMetrics = useSberAds && typeof sberMetricsId === 'number' && sberMetricsId > 0;
    return (React.createElement(React.Fragment, null,
        showYandexMetrics && (React.createElement(YMInitializer, { version: "2", accounts: yandexMetricsIds, options: {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true,
                trackHash: true,
                ecommerce: DATA_LAYER_KEY,
                params: {
                    locale: getLocale()
                }
            } })),
        showSberMetrics && React.createElement(SbesAds, { id: sberMetricsId })));
});
const Analytics = memo(() => {
    const { global: { collectMetrics } } = useConfig();
    if (!isProd || !collectMetrics) {
        return null;
    }
    return React.createElement(AnalyticsComponent, null);
});
export default Analytics;
